/** Money helpers. Everything is stored in minor units (cents) as integers. */
import { BRAND } from './theme.ts';

export const formatCents = (cents: number | null | undefined, currency: string = BRAND.currency): string => {
  if (cents === null || cents === undefined) return '—';
  return new Intl.NumberFormat(BRAND.locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
    maximumFractionDigits: 2,
  }).format(cents / 100);
};

/** Compact rate-card style: R8 500 rather than R8,500.00 */
export const formatCentsCompact = (cents: number): string =>
  BRAND.currencySymbol + new Intl.NumberFormat(BRAND.locale, { maximumFractionDigits: 0 }).format(Math.round(cents / 100));

export interface FeeSplit {
  grossCents: number;
  platformFeeCents: number;
  netToOrganizerCents: number;
}

/**
 * Platform take on a transaction. Percent and flat components stack, which is
 * how the entry-fee rate card is expressed on the pricing page.
 */
export function splitFee(grossCents: number, percent: number, flatCents = 0): FeeSplit {
  const fee = Math.min(grossCents, Math.round((grossCents * percent) / 100) + flatCents);
  return { grossCents, platformFeeCents: fee, netToOrganizerCents: grossCents - fee };
}

/** CPM cost for a delivered impression count. */
export const cpmCost = (impressions: number, cpmCents: number): number =>
  Math.round((impressions / 1000) * cpmCents);
